@if (catalogsheets.length > 0) {
<nz-ribbon [nzText]="countUpdates" nzColor="volcano">
    <nz-collapse nzAccordion>
        <nz-collapse-panel [nzHeader]="titleAccordionTemplate" nzShowArrow="true" [nzActive]="isOpen"
            (nzActiveChange)="onToggle($event)">
            <h3 class="panel-description">{{ 'dashboard.notifDescription' | translate }}:</h3>
            <nz-list nzBordered [nzDataSource]="catalogsheets" id="notification-list">
                @for (catalogsheet of catalogsheets; track catalogsheet) {
                <nz-list-item class="notification-item">
                    <a class="notification-link"
                        [routerLink]="['/catalog-group', catalogsheet.catalogSheetGroupGuid, 'history']"
                        target="_blank">
                        <div class="notification-content" nz-flex nzAlign="center" nzGap="1rem">
                            <span class="info-icon" nz-icon nzType="info-circle" nzTheme="outline"></span>
                            <div nz-flex nzWrap="wrap" nzGap="small">
                                <span class="notification-title">{{catalogsheet.title}}</span>
                                <span>
                                    ({{catalogsheet.labelSector}})
                                    <span class="notif-event-badge"
                                        [class.notif-event-badge-created]="catalogsheet.eventType === 'Created'"
                                        [class.notif-event-badge-updated]="catalogsheet.eventType === 'Updated'">{{
                                        catalogsheet.eventTypeTranslationKey |
                                        translate }}</span>
                                    - {{(catalogsheet.eventAt ??
                                    catalogsheet.createdAt) |
                                    utcDateFormat}}
                                </span>
                            </div>
                        </div>
                    </a>
                </nz-list-item>
                }
            </nz-list>
        </nz-collapse-panel>
    </nz-collapse>
</nz-ribbon>
} @else {
<nz-collapse nzAccordion>
    <nz-collapse-panel [nzHeader]="titleAccordionTemplate" nzShowArrow="true" [nzActive]="isOpen"
        (nzActiveChange)="onToggle($event)">
        <h3 class="panel-description">{{ 'dashboard.notifEmpty' | translate }}</h3>
    </nz-collapse-panel>
</nz-collapse>
}

<ng-template #titleAccordionTemplate>
    <div class="accordion-header">
        <span><b>{{ 'dashboard.notifHeader' | translate }}</b></span>
        <span> <i>
                -
                @if (isOpen) {
                {{ 'dashboard.notifHide' | translate }}
                } @else {
                {{ 'dashboard.notifShow' | translate }}
                }
            </i></span>
    </div>
</ng-template>

<ng-template #countUpdates>
    @if(catalogsheets.length > 0) {
    <span class="totalActionText">{{ 'dashboard.notifRibbon' | translate }} : {{ catalogsheets.length }}</span>
    }
</ng-template>